import './styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { Layout } from './components/Layout';
import {
  HabilitationDetailPage,
  HabilitationFormPage,
  HabilitationsPage,
  UsersPage,
} from './pages/Habilitations';
import {
  ApplicationDetailPage,
  ApplicationFormPage,
  ApplicationsListPage,
  ComplaintsPage,
  TrackingPage,
} from './pages/Demandes';
import { ArchiveItemPage, ArchivesPage, ArchivesToValidate, BatchPage } from './pages/Archives';
import { FinancePage } from './pages/Finance';
import { OrganismPage, PilotagePage } from './pages/Pilotage';
import { ExploitationPage } from './pages/Exploitation';
import { LoginPage, OidcCallbackPage } from './pages/LoginPage';
import { DeliverySpacePage, VerifyPage } from './pages/Delivery';
import { DemarchesPage, HomePage, NotFoundPage } from './pages/PublicPages';
import {
  CasierCentralPage,
  InscriptionDetailPage,
  InscriptionsPage,
  NewInscriptionPage,
  PersonPage,
} from './pages/Registry';
import { AccountPage, AuditPage, PlannedSpacePage, RequireAuth, WorkspaceLayout } from './pages/Workspace';
import { SPACES } from './spaces';
import { AccessGate } from './components/AccessGate';

const planned = SPACES.filter((s) => s.plannedLot !== null);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AccessGate>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="demarches" element={<DemarchesPage />} />
              <Route path="verifier" element={<VerifyPage />} />
              <Route path="verifier/:token" element={<VerifyPage />} />
              <Route path="suivi" element={<TrackingPage />} />
              <Route path="connexion" element={<LoginPage />} />
              <Route path="connexion/retour" element={<OidcCallbackPage />} />
              <Route
                path="espace"
                element={
                  <RequireAuth>
                    <WorkspaceLayout />
                  </RequireAuth>
                }
              >
                <Route index element={<AccountPage />} />
                <Route path="habilitations" element={<HabilitationsPage />} />
                <Route path="habilitations/nouvelle" element={<HabilitationFormPage />} />
                <Route path="habilitations/urgence" element={<HabilitationFormPage emergency />} />
                <Route path="habilitations/utilisateurs" element={<UsersPage />} />
                <Route path="habilitations/:id" element={<HabilitationDetailPage />} />
                <Route path="audit" element={<AuditPage />} />
                <Route path="archives" element={<ArchivesPage />} />
                <Route path="archives/lots/:id" element={<BatchPage />} />
                <Route path="archives/pieces/:id" element={<ArchiveItemPage />} />
                <Route
                  path="juridictions"
                  element={
                    <>
                      <ArchivesToValidate />
                      <InscriptionsPage
                        title="Juridictions"
                        intro="Inscriptions de votre ressort : préparation, soumission, validation par une autre personne."
                      />
                    </>
                  }
                />
                <Route path="casier-central" element={<CasierCentralPage />} />
                <Route path="demandes" element={<ApplicationsListPage mode="usager" />} />
                <Route path="demandes/nouvelle" element={<ApplicationFormPage />} />
                <Route path="demandes/signalements" element={<ComplaintsPage />} />
                <Route path="demandes/:id" element={<ApplicationDetailPage />} />
                <Route path="guichet" element={<ApplicationsListPage mode="guichet" />} />
                <Route path="guichet/nouvelle" element={<ApplicationFormPage counter />} />
                <Route path="finance" element={<FinancePage />} />
                <Route path="pilotage" element={<PilotagePage />} />
                <Route path="technique" element={<ExploitationPage />} />
                <Route path="organismes" element={<OrganismPage />} />
                <Route path="delivrance" element={<DeliverySpacePage />} />
                <Route path="registre/nouvelle" element={<NewInscriptionPage />} />
                <Route path="registre/inscriptions/:id" element={<InscriptionDetailPage />} />
                <Route path="registre/personnes/:id" element={<PersonPage />} />
                {planned.map((s) => (
                  <Route
                    key={s.key}
                    path={s.path.replace('/espace/', '')}
                    element={<PlannedSpacePage spaceKey={s.key} />}
                  />
                ))}
              </Route>
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </AccessGate>
  </StrictMode>,
);

// Coquille hors ligne : en production uniquement (le serveur de développement recharge les modules à chaud).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js'));
}
